<template>
	<v-card flat class="pa-2" color="#eee">
		<div class="pr-2 pl-2 pt-2">		
			<h3>Referenzwert</h3>
			<!-- <p>Laboris nisi ut aliquip ex ea commodo consequat.</p>					 -->
			<p> Ihr Referenzwert für den internationalen Vergleich – HIMSS‘ EMRAM-Stufe (approximiert): </p>
		</div>
		<v-list class="pa-0" color="#eee">
			<v-list-item dense class="mb-2">
				<v-list-item-content>
					<v-list-item-title>
						EMRAM
					</v-list-item-title>
				</v-list-item-content>
				<v-list-item-icon>
					<v-chip color="green" dark>4</v-chip>
				</v-list-item-icon>
			</v-list-item>
		</v-list>
		<p class="caption pr-3 pl-3">
			
		* Wichtig: EMRAM-Stufe und KHZG-Reifegradstufe sind nicht äquivalent, da im Reifegrad nach KHZG wesentlich mehr Kriterien berücksichtigt werden.
		</p>

	</v-card>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	// import Vuex from "vuex";
	// import - from "@/components/"
	export default {
		name: "ReferenceScores", 
		props: {
			
		},
		data: () => {
			return {

			}
		},
		// components: {

		// },
		// computed: {
			// ...Vuex.mapState({})
		// },
		// methods: {
		// }
		// created(){
			
		// }

	}
</script>"